(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6444],{

/***/ 62093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ab_contact_src; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var src = __webpack_require__(145);
// EXTERNAL MODULE: ../packages/ab-link/src/index.tsx
var ab_link_src = __webpack_require__(276);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/formik/dist/formik.esm.js + 5 modules
var formik_esm = __webpack_require__(92151);
// EXTERNAL MODULE: ../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(68301);
// EXTERNAL MODULE: ../packages/ab-gtm/src/datalayer.js
var datalayer = __webpack_require__(6116);
// EXTERNAL MODULE: ../node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(75570);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 28 modules
var dist_esm = __webpack_require__(62062);
// EXTERNAL MODULE: ../packages/ab-input/src/index.tsx
var ab_input_src = __webpack_require__(9215);
// EXTERNAL MODULE: ../packages/ab-form-button/src/index.tsx
var ab_form_button_src = __webpack_require__(81402);
// EXTERNAL MODULE: ../packages/ab-select-country/src/index.tsx
var ab_select_country_src = __webpack_require__(68971);
// EXTERNAL MODULE: ../packages/ab-form-contact/src/ab-form-experiencias.scss
var ab_form_experiencias = __webpack_require__(66674);
;// CONCATENATED MODULE: ../packages/ab-form-contact/src/index.tsx












var ContactForm = function(param) {
    var i18n = param.i18n;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(), host = ref1[0], setHost = ref1[1];
    var ref2 = (0,react.useState)(""), timestamp = ref2[0], setTimestamp = ref2[1];
    var formRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        setHost(window.location.origin);
    }, []);
    var t = (0,dist_esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    var formik = (0,formik_esm/* useFormik */.TA)({
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: true,
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            nif: "",
            mobile: "",
            country: "",
            company: "",
            moreDetails: "",
            comentarios: "",
            gdpr: false,
            captcha: ""
        },
        validationSchema: es/* object */.Ry().shape({
            firstName: es/* string */.Z_().required(t("validationFirstName")),
            lastName: es/* string */.Z_().required(t("validationLastName")),
            email: es/* string */.Z_().email(t("validationEmailContact")).required(t("validationEmailContact")),
            nif: es/* string */.Z_().required(t("validationNIF")),
            mobile: es/* string */.Z_().required(t("validationMobile")),
            moreDetails: es/* string */.Z_().required(t("validationMoreDetails")),
            gdpr: es/* boolean */.O7().isTrue(t("validationPrivacy")),
            captcha: es/* string */.Z_().required(t("validationCaptcha"))
        }),
        onSubmit: function(values) {
            setLoading(true);
            formRef.current.submit();
        }
    });
    var values = formik.values, setFieldValue = formik.setFieldValue, handleSubmit = formik.handleSubmit, errors = formik.errors;
    // console.log("Captcha value:", values, timestamp);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            action: "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
            method: "POST",
            name: "form",
            ref: formRef,
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "captcha_settings",
                    value: JSON.stringify({
                        keyname: "Abadia_Retuerta",
                        fallback: "true",
                        orgId: "00D1t000000Cn69",
                        ts: timestamp || ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "g-recaptcha",
                    "data-sitekey": "6LeZJ_0cAAAAAOLC4p0bMB-CUma_f8bYQSaDt4Tq"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                    element: "span",
                    className: "title",
                    children: t("contact")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                            placeholder: t("firstNameContact"),
                            value: values.firstName,
                            error: errors.firstName,
                            onChange: function(val) {
                                return setFieldValue("firstName", val);
                            },
                            id: "m_first_name",
                            maxLength: "40",
                            name: "first_name"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                            placeholder: t("lastNameContact"),
                            value: values.lastName,
                            error: errors.lastName,
                            onChange: function(val) {
                                return setFieldValue("lastName", val);
                            },
                            id: "m_last_name",
                            maxLength: "80",
                            "data-testid": "last_name",
                            name: "last_name"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                        placeholder: t("emailContact"),
                        value: values.email,
                        error: errors.email,
                        onChange: function(val) {
                            return setFieldValue("email", val);
                        },
                        id: "m_email",
                        maxLength: "80",
                        name: "email"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                            placeholder: t("nifOpasaporte"),
                            value: values.nif,
                            error: errors.nif,
                            onChange: function(val) {
                                return setFieldValue("nif", val);
                            },
                            id: "m_00N1t00000LYoc6",
                            maxLength: "255",
                            name: "00N1t00000LYoc6"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                            placeholder: t("mobile"),
                            value: values.mobile,
                            error: errors.mobile,
                            onChange: function(val) {
                                return setFieldValue("mobile", val);
                            },
                            id: "mobile",
                            maxLength: "40",
                            name: "mobile"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_select_country_src/* default */.Z, {
                            value: values.country,
                            placeholder: t("eligePais"),
                            error: errors.country,
                            onChange: function(e) {
                                return setFieldValue("country", e.target.value);
                            },
                            className: "half ".concat(errors.country ? "error" : ""),
                            id: "m_00N1t00000LYobo",
                            name: "00N1t00000LYobo",
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                            placeholder: t("companyContact"),
                            value: values.company,
                            error: errors.company,
                            onChange: function(val) {
                                return setFieldValue("company", val);
                            },
                            id: "m_company",
                            maxLength: "40",
                            name: "company"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "hidden",
                            id: "00N1t00000LYoc2",
                            name: "00N1t00000LYoc2",
                            value: (i18n === null || i18n === void 0 ? void 0 : i18n.language) == "en" ? "en_US" : i18n === null || i18n === void 0 ? void 0 : i18n.language
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                    value: values.moreDetails,
                    onChange: function(e) {
                        return setFieldValue("moreDetails", e.target.value);
                    },
                    id: "m_00N1t00000LYocG",
                    name: "00N1t00000LYocG",
                    className: "".concat(errors.moreDetails ? "error" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            children: t("moreDetails")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "Hotel",
                            children: t("opcionHotel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "Unique Experiences",
                            children: t("opcionExpUnicas")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "Winehouse",
                            children: t("opcionBodega")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                    element: "span",
                    className: "error",
                    children: errors.moreDetails
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                    element: "span",
                    className: "title",
                    children: t("comments")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                    placeholder: "",
                    value: values.comentarios,
                    onChange: function(e) {
                        return setFieldValue("comentarios", e.target.value);
                    },
                    name: "description",
                    className: "".concat(errors.comentarios ? "error" : "")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                    element: "span",
                    className: "error",
                    children: errors.comentarios
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_input_src/* default */.Z, {
                    type: "checkbox",
                    label: '<a class="gold" href='.concat(host + t("linkPolicy"), " target='_blank'>").concat(t("privacy"), "</a>"),
                    value: values.gdpr,
                    error: errors.gdpr,
                    onChange: function(val) {
                        return setFieldValue("gdpr", val);
                    },
                    id: "m_00N1t00000LYobx",
                    name: "00N1t00000LYobx"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    id: "m_00N1t00000LYoc8",
                    name: "00N1t00000LYoc8",
                    value: "ContactForm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "oid",
                    value: "00D1t000000Cn69"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "retURL",
                    value: "".concat(host).concat(t("/gracias"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "hidden",
                    name: "lead_source",
                    value: "Website"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        maxWidth: 305,
                        overflow: "auto"
                    },
                    children:  true && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                        sitekey: "6LeZJ_0cAAAAAOLC4p0bMB-CUma_f8bYQSaDt4Tq",
                        onChange: function(val) {
                            setFieldValue("captcha", val);
                            setTimestamp(new Date().getTime());
                        },
                        hl: i18n === null || i18n === void 0 ? void 0 : i18n.language
                    })
                }),
                errors.captcha ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "span",
                        className: "error margin",
                        children: errors.captcha
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_form_button_src/* default */.Z, {
                    loading: loading,
                    onClick: function() {
                        return (0,datalayer/* gtmSendContact */.v6)();
                    },
                    disabled: !(values === null || values === void 0 ? void 0 : values.captcha) || errors.captcha,
                    children: t("send")
                })
            ]
        })
    });
};
/* harmony default export */ var ab_form_contact_src = (ContactForm);

// EXTERNAL MODULE: ../packages/ab-contact/src/ab-contact.scss
var ab_contact = __webpack_require__(48626);
;// CONCATENATED MODULE: ../packages/ab-contact/src/index.tsx






var Contact = function(param) {
    var i18n = param.i18n;
    var t = (0,dist_esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-contact",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "span",
                        className: "title",
                        children: t("questions")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "h3",
                        children: t("envienos")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "mailto:info@abadia-retuerta.es",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M7.8514 8.9765C7.4054 8.9765 6.96073 8.82916 6.58873 8.5345L3.59873 6.12383C3.3834 5.9505 3.35007 5.63516 3.52273 5.4205C3.69673 5.2065 4.0114 5.1725 4.22607 5.34516L7.2134 7.75316C7.58873 8.0505 8.1174 8.0505 8.4954 7.7505L11.4527 5.3465C11.6674 5.17116 11.9821 5.2045 12.1567 5.41916C12.3307 5.63316 12.2981 5.94783 12.0841 6.1225L9.1214 8.5305C8.74673 8.82783 8.29873 8.9765 7.8514 8.9765Z",
                                        fill: "#A79669"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                        id: "mask0",
                                        "mask-type": "alpha",
                                        maskUnits: "userSpaceOnUse",
                                        x: "0",
                                        y: "1",
                                        width: "15",
                                        height: "14",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M0.666748 1.33331H15V14.3333H0.666748V1.33331Z",
                                            fill: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                        mask: "url(#mask0)",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M4.55941 13.3333H11.1061C11.1074 13.332 11.1127 13.3333 11.1167 13.3333C11.8774 13.3333 12.5521 13.0613 13.0694 12.5446C13.6701 11.9466 14.0001 11.0873 14.0001 10.1253V5.54665C14.0001 3.68465 12.7827 2.33331 11.1061 2.33331H4.56075C2.88408 2.33331 1.66675 3.68465 1.66675 5.54665V10.1253C1.66675 11.0873 1.99741 11.9466 2.59741 12.5446C3.11475 13.0613 3.79008 13.3333 4.55008 13.3333H4.55941ZM4.54808 14.3333C3.51941 14.3333 2.60075 13.96 1.89141 13.2533C1.10141 12.4653 0.666748 11.3546 0.666748 10.1253V5.54665C0.666748 3.14465 2.34075 1.33331 4.56075 1.33331H11.1061C13.3261 1.33331 15.0001 3.14465 15.0001 5.54665V10.1253C15.0001 11.3546 14.5654 12.4653 13.7754 13.2533C13.0667 13.9593 12.1474 14.3333 11.1167 14.3333H11.1061H4.56075H4.54808Z",
                                            fill: "#A79669"
                                        })
                                    })
                                ]
                            }),
                            "info@abadia-retuerta.es"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "call",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "title",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                                id: "mask0",
                                                "mask-type": "alpha",
                                                maskUnits: "userSpaceOnUse",
                                                x: "9",
                                                y: "1",
                                                width: "7",
                                                height: "7",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M9.56934 1.3335H15.262V7.02204H9.56934V1.3335Z",
                                                    fill: "white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                mask: "url(#mask0)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M14.7618 7.02204C14.5105 7.02204 14.2945 6.83337 14.2658 6.57804C14.0131 4.32737 12.2651 2.58071 10.0138 2.33071C9.7398 2.30004 9.5418 2.05337 9.57247 1.77871C9.60247 1.50471 9.84713 1.30271 10.1245 1.33737C12.8431 1.63937 14.9545 3.74804 15.2591 6.46604C15.2898 6.74071 15.0925 6.98804 14.8185 7.01871C14.7998 7.02071 14.7805 7.02204 14.7618 7.02204Z",
                                                    fill: "#A79669"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M12.4017 7.02924C12.167 7.02924 11.9584 6.86391 11.9117 6.62524C11.7197 5.63857 10.959 4.87791 9.97371 4.68657C9.70238 4.63391 9.52571 4.37191 9.57838 4.10057C9.63104 3.82924 9.89771 3.65191 10.1644 3.70524C11.5517 3.97457 12.623 5.04524 12.893 6.43324C12.9457 6.70524 12.769 6.96724 12.4984 7.01991C12.4657 7.02591 12.4337 7.02924 12.4017 7.02924Z",
                                                fill: "#A79669"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                                id: "mask1",
                                                "mask-type": "alpha",
                                                maskUnits: "userSpaceOnUse",
                                                x: "1",
                                                y: "1",
                                                width: "15",
                                                height: "15",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M1.3335 1.33325H15.0003V15.0003H1.3335V1.33325Z",
                                                    fill: "white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                mask: "url(#mask1)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M2.90622 3.37425C2.90755 3.37425 2.87422 3.40891 2.83222 3.45025C2.67089 3.60691 2.33689 3.93291 2.33355 4.61491C2.32822 5.56891 2.95555 7.34025 5.97622 10.3602C8.98222 13.3656 10.7509 14.0002 11.7076 14.0002H11.7216C12.4036 13.9962 12.7289 13.6622 12.8856 13.5016C12.9329 13.4529 12.9716 13.4162 12.9989 13.3942C13.6636 12.7256 14.0036 12.2289 14.0002 11.9096C13.9962 11.5842 13.5916 11.2002 13.0322 10.6676C12.8542 10.4989 12.6609 10.3142 12.4569 10.1102C11.9276 9.58291 11.6669 9.67291 11.0902 9.87558C10.2936 10.1549 9.20222 10.5376 7.50155 8.83558C5.80022 7.13491 6.18155 6.04358 6.45955 5.24625C6.66089 4.67025 6.75289 4.40825 6.22422 3.87891C6.01755 3.67225 5.83155 3.47625 5.66022 3.29625C5.13089 2.74025 4.74889 2.33825 4.42555 2.33358H4.42022C4.10089 2.33358 3.60489 2.67491 2.90289 3.37691C2.90489 3.37491 2.90555 3.37425 2.90622 3.37425ZM11.7076 15.0002C10.0462 15.0002 7.88022 13.6776 5.26955 11.0676C2.64822 8.44692 1.32355 6.27425 1.33355 4.60958C1.33955 3.50958 1.91622 2.94625 2.13289 2.73492C2.14422 2.72091 2.18289 2.68291 2.19622 2.66958C3.15289 1.71291 3.81022 1.31958 4.43822 1.33358C5.18289 1.34358 5.71355 1.90158 6.38489 2.60758C6.55089 2.78158 6.73022 2.97158 6.93088 3.17158C7.90355 4.14492 7.62689 4.93892 7.40355 5.57625C7.16089 6.27158 6.95089 6.87158 8.20822 8.12892C9.46555 9.38625 10.0649 9.17625 10.7596 8.93158C11.3976 8.70892 12.1896 8.43025 13.1642 9.40358C13.3622 9.60158 13.5489 9.77891 13.7222 9.94358C14.4309 10.6182 14.9909 11.1509 15.0002 11.8976C15.0076 12.5336 14.6209 13.1829 13.6662 14.1376L13.2436 13.8509L13.6016 14.1996C13.3902 14.4162 12.8282 14.9936 11.7276 15.0002H11.7076Z",
                                                    fill: "#A79669"
                                                })
                                            })
                                        ]
                                    }),
                                    t("llamenos")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "left",
                                children: [
                                    t("reservas"),
                                    ":",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "tel:+34 983 687 600",
                                        children: "+34 983 687 600"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "left",
                                children: [
                                    t("oficinas"),
                                    ":",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "tel:+34 983 680 368",
                                        children: "+34 983 680 368"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "left"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "map",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "title",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M8.16716 5.66669C7.52382 5.66669 7.00049 6.19002 7.00049 6.83402C7.00049 7.47735 7.52382 8.00002 8.16716 8.00002C8.81049 8.00002 9.33382 7.47735 9.33382 6.83402C9.33382 6.19002 8.81049 5.66669 8.16716 5.66669ZM8.16716 9.00002C6.97249 9.00002 6.00049 8.02869 6.00049 6.83402C6.00049 5.63869 6.97249 4.66669 8.16716 4.66669C9.36182 4.66669 10.3338 5.63869 10.3338 6.83402C10.3338 8.02869 9.36182 9.00002 8.16716 9.00002Z",
                                                fill: "#A79669"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                                id: "mask0",
                                                "mask-type": "alpha",
                                                maskUnits: "userSpaceOnUse",
                                                x: "2",
                                                y: "1",
                                                width: "12",
                                                height: "14",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M2.66675 1.33334H13.6664V14.3333H2.66675V1.33334Z",
                                                    fill: "white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                mask: "url(#mask0)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M8.1665 2.33334C5.68517 2.33334 3.6665 4.37134 3.6665 6.87534C3.6665 10.0613 7.41584 13.1653 8.1665 13.3307C8.91717 13.1647 12.6665 10.0607 12.6665 6.87534C12.6665 4.37134 10.6478 2.33334 8.1665 2.33334ZM8.1665 14.3333C6.9705 14.3333 2.6665 10.632 2.6665 6.87534C2.6665 3.81934 5.13384 1.33334 8.1665 1.33334C11.1992 1.33334 13.6665 3.81934 13.6665 6.87534C13.6665 10.632 9.3625 14.3333 8.1665 14.3333Z",
                                                    fill: "#A79669"
                                                })
                                            })
                                        ]
                                    }),
                                    t("dondeLocalizarnos")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                className: "span left",
                                children: "Sard\xf3n de Duero "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                className: "span left",
                                children: "47340 Valladolid (Espa\xf1a)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                        prefetch: false,
                        text: t("mapa"),
                        href: "https://goo.gl/maps/AQtzW4MJP5i8S4nH9",
                        target: "__blank"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_form_contact_src, {
                    i18n: i18n
                })
            })
        ]
    });
};
/* harmony default export */ var ab_contact_src = (Contact);


/***/ }),

/***/ 48626:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 66674:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 58772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(90331);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 23615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(58772)();
}


/***/ }),

/***/ 90331:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 75570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(55839);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ../node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ../node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ })

}]);